"use strict";

$.widget("fotobook.popupWidget", $.fotobook.containereditorbasecontrol, {
    _classes : [],
    _create: function () {
        var elements = this.element.children();
        this._classes.push('open-to-top');
        elements.wrapAll(this._baseTpl.supplant({classes: this._classes.join(' ')}));
        this.element.find('.tb-popup-window').prepend(this._closeButtonTpl);
        this._super();
    },
    _processClick: function(event){
        var button = $(event.target);
        var widget = this.widget();

        if (button.hasClass('tb-popup-close')){
            widget.removeClass('active');
        } else if(button.hasClass('tb-popup')) {
            widget.toggleClass('active');
        }
        this._super();
    },
    _baseTpl: '<div class="tb-popup-window {classes}"></div>',
    _closeButtonTpl :  '<div class="edit-icons-sprite tb-button tb-close tb-popup-close"></div>',
});

